export default "/images/banner2.jpg?fccf72798e03534137303479256cca2b";